(() => {
  function initialize(root) {
    if (root.dataset.galleryReady === 'true') return;
    root.dataset.galleryReady = 'true';
    const links = [...root.querySelectorAll('[data-gallery-photo]')];
    const dialog = root.querySelector('dialog');
    if (!links.length || !dialog || typeof dialog.showModal !== 'function') return;
    const image = dialog.querySelector('[data-gallery-image]');
    const caption = dialog.querySelector('[data-gallery-caption]');
    const counter = dialog.querySelector('[data-gallery-counter]');
    const close = dialog.querySelector('[data-gallery-close]');
    let index = 0;
    let opener;
    function display(next) {
      index = (next + links.length) % links.length;
      const source = links[index].querySelector('img');
      image.src = links[index].href;
      image.alt = source.alt;
      image.width = source.naturalWidth || source.width;
      image.height = source.naturalHeight || source.height;
      caption.textContent = links[index].querySelector('[data-gallery-label]').textContent;
      counter.textContent = `${index + 1} / ${links.length}`;
    }
    links.forEach((link, position) => {
      link.addEventListener('click', event => {
        // Preserve normal open-in-new-tab behaviour.
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        opener = link;
        display(position);
        dialog.showModal();
        document.documentElement.classList.add('lr-gallery-scroll-locked');
        close.focus({ preventScroll: true });
      });
    });
    close.addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-gallery-previous]').addEventListener('click', () => display(index - 1));
    dialog.querySelector('[data-gallery-next]').addEventListener('click', () => display(index + 1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); display(index + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); display(index - 1); }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('lr-gallery-scroll-locked');
      opener?.focus({ preventScroll: true });
      image.removeAttribute('src');
    });
  }
  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-lr-gallery]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const dialog = event.target.querySelector('.lr-gallery-dialog[open]');
    if (dialog) dialog.close();
  });
})();
